"use client";
import { motion } from "framer-motion";
import { Server, Lock, Layers, RotateCcw, ArrowRightLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const benefitKeys = [
  { key: "euHosting", icon: Server },
  { key: "encryption", icon: Lock },
  { key: "isolated", icon: Layers },
  { key: "restore", icon: RotateCcw },
  { key: "portability", icon: ArrowRightLeft },
];

const SolutionSection = () => {
  const { t } = useTranslation();

  return (
    <section id="solution" className="py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mx-auto text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-4">
            {t("solution.title")}{" "}
            <span className="text-primary">{t("solution.titleHighlight")}</span>
          </h2>
        </motion.div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {benefitKeys.map((item, i) => (
            <motion.div
              key={item.key}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              whileHover={{ y: -4 }}
              className="rounded-xl p-6 border border-border bg-background shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-10 h-10 rounded-lg bg-trust/10 flex items-center justify-center mb-4">
                <item.icon className="h-5 w-5 text-trust" />
              </div>
              <h3 className="font-display font-semibold text-foreground mb-2">
                {t(`solution.${item.key}.title`)}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {t(`solution.${item.key}.description`)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
